import api from "@/lib/api";
import { consentFor } from "@/lib/analytics";

// Tradedoubler Grow (programma 408784). SDK e identificativi solo con consenso marketing ("ads").
const ORG = 2485098;
const PROG = 408784;
const KEY = "sq_td";
const REFS = "sq_td_refs";
const TTL = 30 * 864e5;
const RX = /^[A-Za-z0-9._-]{8,128}$/;
let pending = "";
let loaded = null;
const inflight = new Set();

const ok = () => consentFor("ads");
const read = (k, d) => { try { return JSON.parse(localStorage.getItem(k) || "null") ?? d; } catch { return d; } };

export function getTd() {
  if (!ok()) { return ""; }
  const v = read(KEY, null);
  return v && RX.test(v.id || "") && Date.now() - v.at < TTL ? v.id : "";
}

// Resolves true only once the official script has really loaded (blocked by an ad blocker -> false, nothing is acknowledged).
function loadSdk() {
  if (!ok()) { return Promise.resolve(false); }
  if (loaded) { return loaded; }
  loaded = new Promise((resolve) => {
    /* eslint-disable */
    (function(i,s,o,g,r,a,m){i['TDConversionObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;a.onload=function(){resolve(true)};a.onerror=function(){loaded=null;resolve(false)};m.parentNode.insertBefore(a,m)})(window,document,'script','https://svht.tradedoubler.com/tr_sdk.js?org='+ORG+'&prog='+PROG+'&dr=true&rand='+Math.random(),'tdconv');
    /* eslint-enable */
    window.tdconv("tracking-consent", true);
  });
  return loaded;
}

function revoke() {
  pending = pending || "";
  [KEY, REFS, "tduid", "tdclid_sn"].forEach((k) => localStorage.removeItem(k));
  localStorage.setItem("tdtrackingconsent", "false");
  const host = window.location.hostname;
  const root = host.split(".").slice(-2).join(".");
  ["tduid", "tdclid_sn", "TRADEDOUBLER"].forEach((c) => {
    [host, `.${root}`].forEach((d) => { document.cookie = `${c}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${d}`; });
    document.cookie = `${c}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
  if (typeof window.tdconv === "function") { window.tdconv("tracking-consent", false); }
}

function sync() {
  if (!ok()) { revoke(); return; }
  localStorage.removeItem("tdtrackingconsent");
  if (pending) { localStorage.setItem(KEY, JSON.stringify({ id: pending, at: Date.now() })); pending = ""; }
  loadSdk();
  read(REFS, []).forEach((r) => fireSale(r.ref, 1));
}

// Called once at app start: tduid from the official link is kept in memory until consent exists.
export function initTradedoubler() {
  const id = new URLSearchParams(window.location.search).get("tduid") || "";
  if (RX.test(id)) { pending = id; }
  window.__sqTd = getTd;
  sync();
  window.addEventListener("sq-consent-accepted", sync);
}

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const saveRefs = (list) => localStorage.setItem(REFS, JSON.stringify(list.filter((r) => Date.now() - r.at < 7 * 864e5)));

// After Stripe returns: the backend decides if a verified Founder Annuale sale exists, the SDK sends it once.
export async function fireSale(ref, tries = 12) {
  if (!ref || !ok() || inflight.has(ref)) { return; }
  const refs = read(REFS, []);
  if (!getTd() && !refs.some((r) => r.ref === ref)) { return; }
  inflight.add(ref);
  if (!refs.some((r) => r.ref === ref)) { saveRefs([...refs, { ref, at: Date.now() }]); }
  try { await run(ref, tries); } finally { inflight.delete(ref); }
}

async function run(ref, tries) {
  for (let n = 0; n < tries; n++) {
    let t = null;
    try { t = (await api.get("/affiliate/td/ticket", { params: { ref } })).data.ticket; } catch { t = null; }
    if (t) {
      if (!(await loadSdk())) { return; }
      window.tdconv("init", String(t.org), { element: "iframe" });
      window.tdconv("track", "sale", { transactionId: t.transactionId, ordervalue: Number(t.ordervalue), voucher: t.voucher, currency: t.currency, event: t.event });
      await sleep(2000);
      await api.post("/affiliate/td/ack", { ref, order_id: t.transactionId }).catch(() => {});
      saveRefs(read(REFS, []).filter((r) => r.ref !== ref));
      return;
    }
    if (n < tries - 1) { await sleep(5000); }
  }
}
